import classNames from 'classnames'
import React, { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './Alert.module.scss'

interface IMargin {
  top?: 'xl'
  bottom?: 'xl'
}
interface IProps {
  text?: string
  margin?: IMargin
  children?: React.ReactNode
  className?: string
  variant?: 'danger' | 'default'
}

export const Alert = ({ text = '', margin, children, className, variant }: IProps) => {
  const styleMods = useMemo(
    () => ({
      [styles['marginTopXl']]: margin?.top === 'xl',
      [styles['marginBottomXl']]: margin?.bottom === 'xl',
      [styles['danger']]: variant === 'danger',
    }),
    [margin, variant]
  )

  if (children) {
    return <div className={classNames(styles.root, styleMods, className)}>{children}</div>
  }

  return (
    <div className={classNames(styles.root, styleMods, className)}>
      <Translation text={text} />
    </div>
  )
}
